export default function () {
    return function (data) {
        return data ? [data.firstName, data.lastName].join(' ') : data;
    }
}
